import PageCard from '@/components/general/PageCard';
import React from 'react';
import styles from './styles.module.css';
import ContactFormInside from '@/components/Forms/ContactFormInside';

export default function ContactusForm() {
  return (
    <PageCard
      title="برای ما پیام بفرستید"
      text="فرم زیر را پر کنید؛ در کمتر از ۲۴ ساعت پاسخ می‌دهیم."
      titleClass={`${styles.titleClass}`}
      textClass={`${styles.textClass}`}
      className={`${styles.card}`}
    >
      <ContactFormInside />
    </PageCard>
  );
}
